import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import ViewProps from '../types/ViewProps'
import ChecklistState from '../types/ChecklistState'
import { useParams } from 'react-router-dom'
import Helmet from 'react-helmet'

export default ({ appState, setAppState, data }: ViewProps) => {

  const LatinAmerica = [
    'Belize',
    'Costa Rica',
    'El Salvador',
    'Guatemala',
    'Honduras',
    'Mexico',
    'Nicaragua',
    'Panama',
    'Argentina',
    'Bolivia',
    'Brazil',
    'Chile',
    'Colombia',
    'Ecuador',
    'Guyana',
    'Paraguay',
    'Peru',
    'Suriname',
    'Uruguay',
    'Venezuela',
    'Cuba',
    'Dominican Republic',
    'Haiti'
  ]

  const [checklistState, setChecklistState] = useState<ChecklistState>({
    errors: [],
    success: []
  })
  const [ revealed, setRevealed ] = useState<boolean>(false)

  if (!revealed) {
    setRevealed(true)
  }

  useEffect(() => {
    document.title = `What You Need to Apply to ECU | Application Helper | Emily Carr University of Art + Design`
  })

  const handleSubmit = (event: any) => {
    event.preventDefault()

    const e = document.querySelector('#email')! as HTMLInputElement
    const ma = document.querySelector('#maquette')! as HTMLInputElement
    const a = document.querySelector('#admissions')! as HTMLInputElement
    const m = document.querySelector('#message')! as HTMLInputElement

    let data = {
      content: `
        <div class="helper">
          <div id="wrapper">
            <div class="helper-wrapper checklist">
              <div class="helper-content">
                ${document.querySelector('.helper-content')!.innerHTML}
              </div>
            </div>
          </div>
      </div>`,
      CRAFT_CSRF_TOKEN: window.csrfTokenValue,
      email: e.value,
      maquette: ma.checked,
      admissions: a.checked,
      message: m.value
    }

    fetch('https://www.ecuad.ca/actions/admissions-helper/admissions', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(res => res.json())
    .then(json => {
      let errors = []
      let success = []

      console.log(json)

      if (json.hasOwnProperty('checklist') && json.checklist !== true) {
        errors.push("Your personalized list could not be sent. Please try again.")
      }
      else {
        success.push('Your personalized list has been sent')
      }

      if (json.hasOwnProperty('admissions') && json.admissions !== true && json.admissions !== "") {
        errors.push("Your message to ECU Admissions could not be sent. Please contact us directly at admissions@ecuad.ca")
      }
      else {
        success.push('Your message to admissions has been received.')
      }

      if (json.hasOwnProperty('maquette') && typeof json.maquette.id === "undefined") {
        const response = JSON.parse(json.maquette)

        if (ma.checked && response.title === 'Member Exists') {
          errors.push("Email address is already signed up for ECU's prospective students newsletter.")
        }
      }
      else {
        if (json.maquette.interests['1aae64d5a9']) {
          success.push("We'll contact you with more information about your application.")
        }
      }

      setChecklistState({ errors: errors, success: success })
    })
    .catch(error => console.log('ERROR:', error))
  }

  return (
    <div className={"helper-wrapper checklist"}>
      <div className="helper-content-wrapper">
        <div className={`helper-content ${revealed ? 'revealed' : ''}`}>
          
          <h1 className="title"><span>What You Need to Apply to ECU</span></h1>

          <div className="checklist-intro-text">
            <p>Everything you need to apply to ECU, all in one place. Still missing something? Contact our Admissions team at <a href="mailto:admissions@ecuad.ca" className="underline">admissions@ecuad.ca</a>.</p>
          </div>
          
          {appState.start !== '' && (
            <blockquote>
              <div className={`blockquote-container`}>
                <div>
                  <h3>When applying to ECU, I will...</h3>
                  <ul>
                    <li>{`Apply as a${appState.start.includes('undergraduate') ? 'n undergraduate student' : ' graduate student'}`}</li>
                    {appState.transfer === 'Yes' && (
                      <a href="https://www.ecuad.ca/admissions/application-info/undergraduate-applications/other-applications" target="_blank">
                        <li>Check to see if I am eligible to transfer my college or university-level credits</li>
                      </a>
                    )}
                    {appState.citizenship === 'Yes' && (
                      <li>Be considered a domestic student</li>
                    )}
                    {appState.citizenship !== 'Yes' && (
                      <li>Be considered an international student</li>
                    )}
                    {appState.language === 'No' && (
                      <li>Be required to submit my English Proficiency Test scores with my application</li>
                    )}
                  </ul>

                </div>
                <footer>

                </footer>
              </div>
            </blockquote>
          )}

          <h2>Information You Requested</h2>
          <p>Based on your answers for each topic, we've gathered these links for you to check out.</p>
          
          {appState.start.indexOf('an undergraduate') !== -1 && (
            <div className="selected-programs">
              <h3>Undergraduate Program Information</h3>
              <ul>
                <li>
                  <a href="https://www.ecuad.ca/academics/undergraduate-degrees/first-year-foundation" target="_blank">
                    <div>
                      <h4>Foundation Year</h4>
                      <p>Whether you arrive at ECU with a major in mind, or you’re curious about every possible path, first-year Foundation will prepare you for your creative future.</p>
                    </div>
                  </a>
                </li>
                {appState.undergraduatePrograms.map(p => 
                  <li>
                    <a href={p.page} target="_blank">
                      <div>
                        <h4>{p.name}</h4>
                      </div>
                    </a>
                  </li>
                )}
              </ul>
              <h4><a href="https://www.ecuad.ca/all-programs#undergrad" target="_blank">See all undergraduate program options</a></h4>
            </div>
          )}
          {appState.start.indexOf('a graduate') !== -1 && (
            <div className="selected-programs">
              <h3>Graduate Program Information</h3>
              <ul>
                <li>
                  <a href="https://www.ecuad.ca/all-programs#grad" target="_blank">
                    <div>
                      <h4>Learn about our {appState.graduatePrograms}</h4>
                    </div>
                  </a>
                </li>
              </ul>
              <h4><a href="https://www.ecuad.ca/all-programs#grad" target="_blank">See all graduate program options</a></h4>
            </div>
          )}

          <h3>Applying to ECU</h3>
          <div className={"checklist-items"}>
            {appState.applying.find(a => a.name === 'Application deadlines') && appState.start.indexOf('an undergraduate') !== -1 && (
              <a href="https://www.ecuad.ca/admissions/application-info/undergraduate-applications/how-to-apply" target="_blank">
                <div className={"checklist-item"}>
                  <div>
                    <div className={"checklist-item-content"}>
                      <h4>The deadline for entry to the Fall term is January 15</h4>
                      <p>See our How to Apply guide for all deadlines.</p>
                    </div>
                  </div>
                </div>
              </a>
            )}
            {appState.applying.find(a => a.name === 'Application deadlines') && appState.start.indexOf('a graduate') !== -1 && (
              <a href="https://www.ecuad.ca/admissions/application-info/graduate-applications/how-to-apply" target="_blank">
                <div className={"checklist-item"}>
                  <div>
                    <div className={"checklist-item-content"}>
                      <h4>The application deadline is January 15</h4>
                      <p>See our How to Apply guide for other key dates. </p>
                    </div>
                  </div>
                </div>
              </a>
            )}

            {/* PORTFOLIO REQUIREMENTS */}
            {appState.applying.find(a => a.name === 'Portfolio requirements') && appState.transfer === 'Yes' && appState.start.indexOf('an undergraduate') !== -1 && (
              <a href="https://www.ecuad.ca/admissions/application-info/undergraduate-applications/application-requirements">
                <div className={"checklist-item"}>
                  <div>
                    <div className={"checklist-item-content"}>
                      <h4>Review portfolio requirements – transfer students</h4>
                    </div>
                  </div>
                </div>
              </a>
            )}
            {appState.applying.find(a => a.name === 'Portfolio requirements') && appState.transfer === 'No' && appState.start.indexOf('an undergraduate') !== -1 && (
              <a href="https://www.ecuad.ca/admissions/application-info/undergraduate-applications/application-requirements">
                <div className={"checklist-item"}>
                  <div>
                    <div className={"checklist-item-content"}>
                      <h4>Review portfolio requirements – undergraduate students</h4>
                    </div>
                  </div>
                </div>
              </a>
            )}
            {appState.applying.find(a => a.name === 'Portfolio requirements') && appState.transfer === 'No' && appState.start.indexOf('a graduate') !== -1 && (
              <a href="https://www.ecuad.ca/admissions/application-info/graduate-applications/portfolio-supporting-documents">
                <div className={"checklist-item"}>
                  <div>
                    <div className={"checklist-item-content"}>
                      <h4>Review portfolio requirements</h4>
                    </div>
                  </div>
                </div>
              </a>
            )}

            {/* ACADEMIC REQUIREMENTS */}
            {appState.applying.find(a => a.name === 'Academic requirements (grades)') && appState.start.indexOf('an undergraduate') !== -1 && appState.location === 'Canada' && (
              <a href="https://www.ecuad.ca/admissions/application-info/undergraduate-applications/application-requirements#requirements" target="_blank">
                <div className={"checklist-item"}>
                  <div>
                    <div className={"checklist-item-content"}>
                      <h4>Review academic requirements</h4>
                    </div>
                  </div>
                </div>
              </a>
            )}
            {appState.applying.find(a => a.name === 'Academic requirements (grades)') && appState.start.indexOf('an undergraduate') !== -1 && appState.location === 'China' && (
              <a href="https://www.ecuad.ca/admissions/application-info/undergraduate-applications/first-year-academic-requirements#other-international-applicants" target="_blank">
                <div className={"checklist-item"}>
                  <div>
                    <div className={"checklist-item-content"}>
                      <h4>Review academic requirements</h4>
                      <p>Applicants from China (excluding Hong Kong) must verify their educational documents through China Credentials Verification (CHESICC). Send your documents to this Chinese agency for verification in English. Ask the agency to send your official academic transcript and English verification report directly to:</p>
                    </div>
                  </div>
                </div>
              </a>
            )}
            {appState.applying.find(a => a.name === 'Academic requirements (grades)') && appState.start.indexOf('an undergraduate') !== -1 && LatinAmerica.includes(appState.location) && (
              <a href="https://www.ecuad.ca/admissions/application-info/undergraduate-applications/first-year-academic-requirements#other-international-applicants#latin-america" target="_blank">
                <div className={"checklist-item"}>
                  <div>
                    <div className={"checklist-item-content"}>
                      <h4>Review academic requirements</h4>
                    </div>
                  </div>
                </div>
              </a>
            )}
            {appState.applying.find(a => a.name === 'Academic requirements (grades)') && appState.start.indexOf('a graduate') !== -1 && (
              <a href="https://www.ecuad.ca/admissions/application-info/graduate-applications/academic-requirements" target="_blank">
                <div className={"checklist-item"}>
                  <div>
                    <div className={"checklist-item-content"}>
                      <h4>Review academic requirements</h4>
                    </div>
                  </div>
                </div>
              </a>
            )}

            {/* APPLICATION STEPS */}
            {appState.applying.find(a => a.name === 'Application steps') && appState.start.indexOf('an undergraduate') !== -1 && (
              <a href="https://www.ecuad.ca/admissions/application-info/undergraduate-applications/how-to-apply" target="_blank">
                <div className={"checklist-item"}>
                  <div>
                    <div className={"checklist-item-content"}>
                      <h4>Read our three-step guide for applying to ECU</h4>
                    </div>
                  </div>
                </div>
              </a>
            )}
            {appState.applying.find(a => a.name === 'Application steps') && appState.start.indexOf('a graduate') !== -1 && (
              <a href="https://www.ecuad.ca/admissions/application-info/graduate-applications/how-to-apply" target="_blank">
                <div className={"checklist-item"}>
                  <div>
                    <div className={"checklist-item-content"}>
                      <h4>Read our simple step-by-step guide on how to apply</h4>
                    </div>
                  </div>
                </div>
              </a>
            )}

            {appState.citizenship !== 'Yes' && appState.citizenship !== '' && appState.start.indexOf('a graduate') !== -1 && (
              <a href="https://www.ecuad.ca/admissions/application-info/graduate-applications/how-to-apply">
                <div className={"checklist-item"}>
                  <div>
                    <div className={"checklist-item-content"}>
                      <h4>Find out if you need a visa or study permit</h4>
                    </div>
                  </div>
                </div>
              </a>
            )}
            {appState.citizenship !== 'Yes' && appState.citizenship !== '' && appState.start.indexOf('an undergraduate') !== -1 && (
              <a href="https://www.ecuad.ca/admissions/application-info/undergraduate-applications/how-to-apply">
                <div className={"checklist-item"}>
                  <div>
                    <div className={"checklist-item-content"}>
                      <h4>Find out if you need a visa or study permit</h4>
                    </div>
                  </div>
                </div>
              </a>
            )}
            {appState.language === 'No' && (
              <a href="https://www.ecuad.ca/admissions/application-info/undergraduate-applications/application-requirements#english" target="_blank">
                <div className={"checklist-item"}>
                  <div>
                    <div className={"checklist-item-content"}>
                      <h4>Review English language proficiency requirements</h4>
                    </div>
                  </div>
                </div>
              </a>
            )}
            {appState.indigenous === 'Yes' && (
              <div className={"checklist-item"}>
                <div>
                  <div className={"checklist-item-content"}>
                    <h4>Review <a href="https://www.ecuad.ca/admissions/application-info/undergraduate-applications/" target="_blank">Aboriginal Admissions Policy</a> and Review <a href="https://www.ecuad.ca/student-life/financial-aid-awards/funding-for-aboriginal-students" target="_blank">Funding for Aboriginal Students</a></h4>
                    <p>We are dedicated to providing access and support for all applicants and particularly underrepresented populations. Indigenous applicants who are 19 years of age or older and who do not meet the current academic standing will be considered for admission based on other factors.</p>
                  </div>
                </div>
              </div>
            )}
          </div>

          <h3>Finances</h3>

          <div className={"checklist-items"}>
            {appState.finances.find(f => f.name === 'Program costs (tuition and fees)') && appState.start.indexOf('an undergraduate') !== -1 && appState.location === 'Canada' && appState.indigenous === 'No' && (
              <a href="https://www.ecuad.ca/about/administration/financial-services/tuition-fees/undergraduation-tuition-and-fees" target="_blank">
                <div className={"checklist-item"}>
                  <div>
                    <div className={"checklist-item-content"}>
                      <h4>Learn about program costs (tuition and fees)</h4>
                    </div>
                  </div>
                </div>
              </a>
            )}
            {appState.finances.find(f => f.name === 'Program costs (tuition and fees)') && appState.start.indexOf('an undergraduate') !== -1 && appState.location === 'Canada' && appState.indigenous === 'No' && (
              <a href="https://www.ecuad.ca/about/administration/financial-services/tuition-fees/undergraduation-tuition-and-fees" target="_blank">
                <div className={"checklist-item"}>
                  <div>
                    <div className={"checklist-item-content"}>
                      <h4>Learn about program costs (tuition and fees)</h4>
                    </div>
                  </div>
                </div>
              </a>
            )}

            {appState.finances.find(f => f.name === 'Program costs (tuition and fees)') && appState.start.indexOf('a graduate') !== -1 && (
              <a href="https://www.ecuad.ca/about/administration/financial-services/tuition-fees/graduate-tuition-fees" target="_blank">
                <div className={"checklist-item"}>
                  <div>
                    <div className={"checklist-item-content"}>
                      <h4>Learn about program costs (tuition and fees)</h4>
                    </div>
                  </div>
                </div>
              </a>
            )}

            {appState.finances.find(f => f.name === 'Relevant funding and scholarships') && appState.start.indexOf('an undergraduate') !== -1 && (
              <a href="https://www.ecuad.ca/student-life/financial-aid-awards/funding-for-undergraduate-students">
                <div className={"checklist-item"}>
                  <div>
                    <div className={"checklist-item-content"}>
                      <h4>Discover relevant grants and scholarships</h4>
                    </div>
                  </div>
                </div>
              </a>
            )}
            {appState.finances.find(f => f.name === 'Student loans and financing') && appState.indigenous === 'No' && (
              <a href="https://www.ecuad.ca/student-life/financial-aid-awards/funding-for-undergraduate-students/student-loans">
              <div className={"checklist-item"}>
                <div>
                  <div className={"checklist-item-content"}>
                    <h4>Learn about student loans and financing</h4>
                  </div>
                </div>
              </div>
              </a>
            )}
            {appState.finances.find(f => f.name === 'Student loans and financing') && appState.indigenous === 'Yes' && (
              <a href="https://www.ecuad.ca/student-life/financial-aid-awards/funding-for-aboriginal-students">
                <div className={"checklist-item"}>
                  <div>
                    <div className={"checklist-item-content"}>
                      <h4>Learn about student loans and financing</h4>
                    </div>
                  </div>
                </div>
              </a>
            )}
            {appState.finances.find(f => f.name === 'Cost of living in Vancouver') && (
              <a href="https://www.ecuad.ca/about/administration/financial-services/tuition-fees/undergraduation-tuition-and-fees" target="_blank">
                <div className={"checklist-item"}>
                  <div>
                    <div className={"checklist-item-content"}>
                      <h4>Learn about the typical costs of living for a student in Vancouver.</h4>
                    </div>
                  </div>
                </div>
              </a>
            )}
          </div>
        </div>
        <div className={'checklist-email'}>
          <div className={'checklist-email-container'}>
            <h2>Get a Copy of this List by Email</h2>

            <form action="http://ecuad.localhost/actions/admissions-helper/admissions" method="POST" onSubmit={handleSubmit}>
              <input type="email" placeholder="Your Email" name="email" id="email" required />

              <div id="errors">
                {checklistState.errors.length > 0 && checklistState.errors.map(e => (<p className="error" key={e}>{e}</p>))}
                {checklistState.success.length > 0 && checklistState.success.map(e => (<p className="success" key={e}>{e}</p>))}
              </div>

              <div className={"checklist-item"}>
                <input type="checkbox" name="maquette" id="maquette"></input>
                <div>
                  <div className={"checklist-item-content"}>
                    <h4>Sign up for ECU’s prospective students newsletter to get reminders about upcoming deadlines and application information.</h4>
                  </div>
                </div>
              </div>

              <div className={"checklist-item"}>
                <input type="checkbox" name="admissions" id="admissions"></input>
                <div>
                  <div className={"checklist-item-content"}>
                    <h4>I have a question and want to contact ECU Admissions.</h4>
                    <p>We'll include a copy of your to-do list along with your message</p>
                    <textarea placeholder="Your message" name="message" id="message"></textarea>
                  </div>
                </div>
              </div>

              <input type="hidden" name="content" id="content" value="" />
              <input type="hidden" name="CRAFT_CSRF_TOKEN" value={window.csrfTokenValue} />
              
              <input type="submit" value="Complete" />
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}